import angular from 'angular';
import { DrawerMenuBarItemComponent } from './drawer-menu-bar-item.component';

const MODULE_NAME = 'core.component.layout.drawer-menu-bar-item';

angular.module(MODULE_NAME, []).component('esDrawerMenuBarItem', DrawerMenuBarItemComponent);

export default MODULE_NAME;
